module.exports = __webpack_public_path__ + "static/media/ma.da2a6dcc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ma.svg
// module id = 2148
// module chunks = 0